import { ref, computed } from 'vue';

export default (isFocused = false) => {
  const focused = ref(isFocused);
  const classes = computed(() => ({
    'c-textarea-focus': focused.value,
  }));
  return { focused, classes };
};
